import React, { useEffect, useRef, useState } from 'react';
import { PopupButton } from 'react-calendly';
import { animateScroll as scroll } from 'react-scroll';
import RingSpinner from '../../components/Three/RingSpinner';
import './LandingPage.css';
import ThreeCanvas from '../../components/Three/ThreeCanvas';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

/** Low-distraction, phone-first landing for Insta ads */
export default function LandingPage() {
  const myRef = useRef(null);

  const [currentSection, setCurrentSection] = useState(0);


  /* IntersectionObserver – track which section is in view */
  useEffect(() => {
    const sections = document.querySelectorAll('.snap-section');
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setCurrentSection([...sections].indexOf(entry.target));
          }
        });
      },
      { threshold: 0.5 },
    );
    sections.forEach(s => observer.observe(s));
    return () => sections.forEach(s => observer.unobserve(s));
  }, []);

  /*— lightweight event tracking with Plausible —*/
  useEffect(() => {
    window.plausible?.('instagram_landing_visit');        // page-view event
  }, []);

  const handleBook = () => {
    window.plausible?.('booking_click');
  };

  const handleMore = () => {
    window.plausible?.('more_details_click');
    myRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="insta-landing">
    <main className="snap-container">
      {/* ————— HERO ————— */}
      <section className="snap-section landing-hero">
        {/* top‑left “back home” button */}
        <Link to="/" className="landing‑back">
          <Home size={20} strokeWidth={2.4} />
        </Link>

        <img
          src="/CustomCaratsLogoLarge.png"
          alt="CustomCarats"
          className="landing-logo"
        />
        <h1 className="landing-sale-title">Opening Sale</h1>
        <p className="landing-tagline">
          Any bespoke diamond ring<br />
          up&nbsp;to&nbsp;2 ct VVS diamonds<br />
          free moissanite travel ring<br />
          <strong>£1499 fixed</strong>
        </p>

        <PopupButton
          url="https://calendly.com/customcarats/30min"
          rootElement={document.getElementById('root')}
          className="btn btn-primary landing-book"
          text="Book Free Consultation"
          onClick={handleBook}
        />

        <button className="btn btn-secondary landing-more" onClick={handleMore}>
          Offer Details
        </button>

        {/* ring lives in its own block, below the buttons */}
        {/* <div className="ring-block">
          <RingSpinner />
        </div> */}
      </section>

      {/* ————— DETAILS ————— */}
      <section ref={myRef} className="snap-section landing-details">
        <h2>What’s Included</h2>
        <ul>
          <li>Up to 2.0 ct VVS diamonds &nbsp;|&nbsp; any shape.</li>
          <li>14ct white or yellow gold (up to 4 grams).</li>
          <li>Matching moissanite & silver travel ring.</li>
          <li>IGI certificates for relevant diamonds.</li> 
          <li>4-week turnaround.</li>
          <li>20% deposit · Flexible 0% payment plans.</li>
        </ul>

        <h3>Extras</h3>
        <ul>
          <li>Upgrade to 18ct gold £75</li>
          <li>Gold plate travel ring £50</li>
          <li>Engraving £20.</li>
          <li>Express 2-week crafting £250.</li>
        </ul>

        <h3>Terms &amp; Conditions</h3>
        <small>
          Offer valid until 31 May 2025. Price includes VAT. Deposit becomes
          non-refundable once CAD design is approved.
          Standard 1 year warranty applies. See full terms at&nbsp;
          <a href="/terms" target="_blank" rel="noopener noreferrer">customcarats.com/terms</a>.
        </small>
      </section>
      <ThreeCanvas isSalePage={true} currentSection={currentSection} className="ThreeCanvasSale"/>
      </main>
    </div>
  );
}
